<template>
  <div>
    <div class="row">
      <div class="col-12 mb-2">
        <div class="row align-items-center text-center">
          <div class="col-12 text-center">
            <button class="btn iconed btn-secondary" v-b-modal.problem-type><i
              class="icon-bd-plus"></i><span>جدید</span></button>
          </div>
        </div>
      </div>
      <div v-if="isLoading"  class="col-lg-12 p-0">
        <Preloader/>
      </div>
      <div class="col-lg-12 p-0" v-else>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col" class="text-center">عملیات</th>
            <th scope="col" class="text-center">ردیف</th>
            <th scope="col" class="text-center">علت ضایعات</th>
            <th scope="col" class="text-center">توضیحات</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) of damageTypes">
            <td class="text-center">
              <button :id="'btn-problem-' + item.id" class="btn btn-secondary ml-2"
                      @click="editdamageType(item, index)"
                      data-toggle="tooltip"><i class="icon-bd-pencil"></i>
              </button>
              <button :id="'btn-delete-' + item.id" class="btn btn-secondary"
                      @click="onDeleteClicked(item, index)"><i class="icon-bd-delete"></i></button>
            </td>
            <th scope="row" class="text-center">{{index + 1}}</th>
            <td class="text-center">{{item.name}}</td>
            <td class="text-center">{{item.description}}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <b-modal
      id="problem-type"
      ref="damageTypeModal"
      title="تعریف علت ضایعات"
      ok-title="ذخیره"
      cancel-title="بستن"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="علت ضایعات"
          label-for="name-input"
          invalid-feedback="علت ضایعات الزامیست"
        >
          <b-form-input
            id="name-input"
            v-model="name"
            :state="nameState"
            required
          ></b-form-input>

        </b-form-group><b-form-group
          label="توضیحات"
          label-for="name-input"
          invalid-feedback="علت ضایعات الزامیست"
        >
          <b-form-input
            id="name-input"
            v-model="description"
            :state="nameState"
            required
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>


  </div>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  import BaseService from "../../_framework/api/BaseService.js";
  import {mapState} from "vuex";

  export default {
    name: "damageType",
    components: {
      VsTable,
    },
    data() {
      return {
        access: {},
        damageTypes: [],
        deleteButtonState: 'primary',
        data: '',
        submittedNames: [],
        nameState: null,
        name: '',
        description: '',
        editdamageTypeFlag: false,
        damageType: {},
        isLoading: false,
      }
        ;
    },
    mounted() {
      this.getdamageType();
    },
    methods: {

      getdamageType() {
        this.isLoading = true;
        new BaseService('WorkProblems', '/GetdamageTypes').getList().then((response) => {
          // console.log(response.data);
          this.damageTypes = response.data;
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          console.log(error)
        })
      },
      onDeleteClicked(item) {
        const $btnDel = $(`#btn-delete-${item.id}`);
        if (!$btnDel.hasClass("btn-danger")) {
          $btnDel.addClass("btn-danger");
          setTimeout(() => {
            $btnDel.removeClass("btn-danger");
          }, 2000);
        } else {
          new BaseService('WorkProblems', `/DeletedamageType/${item.id}`).delete().then((response) => {
            this.$noty.success("حذف با موفقیت انجام شد");
            this.getdamageType();
          }).catch((error) => {
            console.log(error)
          });
        }
      },
      createdamageType() {
        let createdamageType = {
          name: this.name,
          description : this.description
        };
        new BaseService('WorkProblems', '/CreatedamageType').create(createdamageType).then((response) => {
          this.$noty.success("ثبت با موفقیت انجام شد");
          this.getdamageType();
        }).catch((error) => {
          console.log(error)
        });
      },
      updatedamageType(obj) {
        let updatedamageType = {
          id: obj.id,
          name: this.name,
          description: this.description,
        };

        new BaseService('WorkProblems', '/UpdatedamageType').update(updatedamageType).then((response) => {
          this.$noty.success("تغییرات با موفقیت صورت گرفت");
          this.getdamageType();
          this.editdamageTypeFlag = false;
        }).catch((error) => {
          console.log(error)
        });
      },
      onShowProblemItems(item) {
        this.$refs['damageTypeDetail'].show();
        this.damageType = item;
      },
      editdamageType(item, index) {
        this.editdamageTypeFlag = true;
        this.$refs['damageTypeModal'].show();
        this.name = item.name;
        this.description = item.description;
        this.damageType = item;
      },
      onCancelClicked() {

      },
      checkFormValidity() {
        const valid = this.$refs.form.checkValidity();
        this.nameState = valid ? 'valid' : 'invalid';
        return valid
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        }
        // Push the name to submitted names
        this.submittedNames.push(this.name);
        // Hide the modal manually
        this.$nextTick(() => {
          this.$refs.damageTypeModal.hide()
          this.editdamageTypeFlag = false
        })
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault();
        // Trigger submit handler
        this.handleSubmit();
        if (this.editdamageTypeFlag === false) {
          this.createdamageType(this.name)
        } else {
          this.updatedamageType(this.damageType);
          this.editdamageTypeFlag = false;
        }
      },
      resetModal() {
        this.name = '';
        this.nameState = null;
      },


    },
    created: () => {
    },
    /*beforeMount() {
        this.options.access = checkAccess(this.$route.path);
        //console.log(this.options.access);
        this.show = !!this.options.access;
    },*/
    computed: {
      ...mapState(["selectedRows", "currentService", "vsTableFeed"]),

    }
  };
</script>



